var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatePalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78699 4.00024V10.0002M9.78699 10.0002H3.96954M9.78699 10.0002L2 2.21326M5 1.00024H12C13.6569 1.00024 15 2.34339 15 4.00024V12.0002C15 13.6571 13.6569 15.0002 12 15.0002H4C2.34315 15.0002 1 13.6571 1 12.0002V5.00024",
    stroke: "#7B7986",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePalette);
export default __webpack_public_path__ + "static/media/createPalette.b5ef3cb2af853874d039d943c19bc004.svg";
export { ForwardRef as ReactComponent };